module.exports = __webpack_public_path__ + "static/media/de00.2c607ee0.jpg";